// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React, { useState, useEffect } from 'react';
import * as styles from '../styles/OpenAiWidget.styles';

const TOTAL_STEPS = 5;

const InterviewStepper = (): JSX.Element => {
  const [step, setStep] = useState<number>(1);

  useEffect(() => {
    if (step >= TOTAL_STEPS) return;

    const timer = setInterval(() => {
      setStep((prev) => prev + 1);
    }, 120000);

    return () => clearInterval(timer);
  }, [step]);

  return (
    <div style={styles.assessmentProgressRootStyle}>
      <p style={styles.assessmentProgressLabelStyle}>Assessment progress</p>
      <div style={styles.assessmentProgressSegmentsStyle}>
        {Array.from({ length: TOTAL_STEPS }, (_, i) => (
          <div
            key={i}
            style={
              step === i + 1
                ? styles.assessmentProgressSegmentActiveStyle
                : styles.assessmentProgressSegmentInactiveStyle
            }
          />
        ))}
      </div>
    </div>
  );
};

export default InterviewStepper;
